export const CONTACT_US_CONFIG = {
  sectionId: 'contactUs',
  heading: 'Contact Us',
}
